/**
 @ngdoc service
 @name mapExternaladvertTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapExternaladvertTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            //tileFactory.addFieldToColumn1(tileFactory.field.newField('jobID'));

            tileFactory.addFieldToColumn1(tileFactory.field.newField('sector'));
            tileFactory.addFieldToColumn1(tileFactory.field.newField('subSector'));

            tileFactory.addStatus(tileFactory.status.newLabelAndNumericValueStatus('numApplicants'));

            //tileFactory.addFieldToColumn2(tileFactory.field.newField('numApplicants'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('recruiterName')); //Company
            tileFactory.addFieldToColumn2(tileFactory.field.newField('location'));

            tileFactory.addFieldToColumn3(tileFactory.field.newRatePerUnitRangeFieldLite('payFrom','payTo', 'payType'));

            //tileFactory.addFieldToColumn3(tileFactory.field.newField('payType'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('jobType'));


            tileFactory.addFieldToColumn4(tileFactory.field.newField('postedDate','date'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('updatedDate','date'));

            //tileFactory.addFieldToFullWidthRow(tileFactory.field.newField('advertURL'));
            tileFactory.addCallToAction(tileFactory.callToAction.newCallToActionModal('advertPreviewURI', 'advertPreviewURI'));



            console.log('tileFactory.tileData',tileFactory.tileData);

            return tileFactory.tileData;
        };
        return {
            map : map
        };
    };

    mapExternaladvertTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapExternaladvertTileService', mapExternaladvertTileService);

}());